import { Typography } from '@mui/material';
import React from 'react';

const SearchFilterHeader: React.FC<{ title: JSX.Element | string }> = ({
  title
}) => {
  return <Typography sx={{ p: 1, pb: 1.3 }}>{title}</Typography>;
};

export default SearchFilterHeader;
